import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';

import { DeleteBlockadeResponse } from '../../../../../store/api/blockades/blockades.types';
import { deleteBlockade } from '../../../../../store/api/blockades/blockadesActions';

import { UnlockButton } from './UnlockButton';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onDeleteBlockade: (blockadeId: string) => dispatch<Promise<DeleteBlockadeResponse>>(deleteBlockade(blockadeId)),
});

export const UnlockButtonContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(UnlockButton);
